export default __webpack_public_path__ + "static/media/mauern-3.1298ab6d.jpeg";